<template lang="pug">
.location-box
	h3.location-box__name
		a(:href="location.url") {{ location.city }} {{ location.state }}
	address.location-box__address
		div {{ addressDisplayString }}
		div {{ location.city }}, {{ location.state }} {{ location.zipCode.substring(0, 5) }}
	.location-box__phone
		a(:href="'tel:' + location.phone") {{ location.phone }}
	a(:href="'https://www.google.com/maps/place/' + addressDirectionsHref", target="_blank").location-box__directions Get Directions 
</template>

<script>

export default {
	name: "LocationBox",
	props: {
		location: Object
	},
	computed: {
		addressDisplayString() {
			return this.location.address1 + (!!this.location.address2 ? ", " + this.location.address2 : "");
		},
		addressDirectionsHref() {
			let string = this.location.address1 + " " + (!!this.location.address2 ? this.location.address2 + " " : "") + this.location.city + " " + this.location.state + " " + this.location.zipCode;
			return encodeURI(string);
		}
	}
}
</script>

<style lang="scss" scoped>
.location-box {
	padding: 2rem 2rem 2rem 3rem;
	flex: 1 1 100%;
	background: $offWhiteGray;
	@include mq(md) {
		flex: 1 1 calc(50% - 0.75rem);
		max-width: calc(50% - 0.75rem);
	}
	&__name {
		margin-bottom: 0.6325rem;
	}
	&__address {
		font-style: normal;
		font-size: 0.875rem;
		color: $darkGray;
		line-height: 1.3125rem;
		font-family: $fontFamilyHeadings;
		font-weight: 500;
		margin-bottom: 0;
		@include mq(sm) {
			font-size: 1.125rem;
			line-height: 1.575rem;
		}
	}
	&__phone {
		position: relative;
		a {
			display: block;
			line-height: 1.575rem;
			margin: 0.75rem 0;
			@include mq(sm) {
				margin: 0;
				background: none;
				font-size: 1.125rem;
				line-height: 2.25rem;
			}
		}
	}
	&__directions {
		display: block;
		margin: 0.75rem 0;
		font-size: 0.875rem;
		line-height: 1.4;
		@include mq(sm) {
			display: none;
			visibility: hidden;
		}
	}
}
</style>